<template>
    <ItemMenuList :isLoading="isLoading" class="grouped">
        <template slot="Content">
            <template v-if="boxListGrouped != null" v-for="section in boxListGrouped" >
                <div :class="['category']">
                    <i @click='toggleSection(section.key)'
                       :class="['fas', section.expanded ? 'fa-chevron-down' : 'fa-chevron-right' ]">
                    </i>
                    <router-link tag="a" :to="{name:'BoxList', params:{boxType:section.key}}">
                        <a href="#">{{ section.key === 'UNDEFINED' ? 'PLAYLIST' : section.key }}</a>
                    </router-link>
                </div>
                <b-list-group :class="[section.expanded ? 'expanded':'collapsed' ]">
                    <ul class="reset-style">
                        <li
                                v-for="box in section.items"
                                :key="box.uid"
                                :class="box.colorCode">
                            <MenuCard
                                    :menuItem="box"
                                    :itemType="'box'"
                                    :isDroppable="true"
                                    @click="$router.push({ name: isSmartBox(box), params: { boxUid: box.uid }})"
                                    :href="{name: isSmartBox(box), params:{boxUid: box.uid}}">
                                <template slot="Decorator">
                                    <i class="fas fa-box-open" :style="{ color: box.colorCode }"></i>
                                </template>
                                <template slot="Badge">
                                    <!-- <div> -->
                                        <b-badge variant="primary" pill>
                                            <span v-if="box.type === Constants.boxTypes.SMARTBOX.value || Constants.boxTypes.SMARTBOX.key.localeCompare(box.type) === 0">
                                                <i class="fas fa-bolt"></i>
                                            </span>
                                            <span v-else>
                                                {{box.statistics.trackCount}}
                                            </span>
                                        </b-badge>
                                    <!-- </div> -->
                                </template>
                                <!-- <span class="bar-item" :style="{ backgroundColor: box.colorCode }"></span> -->
                            </MenuCard>
                        </li>
                    </ul>
                </b-list-group>
                <!--<div v-else class="alert alert-info">
                    No Box found
                </div>-->
            </template>
        </template>
        <template slot="Actions">
            <BoxCreationButton :empty="true"></BoxCreationButton>
        </template>
    </ItemMenuList>
</template>
<script>
    import { mapState, mapActions, mapGetters } from 'vuex'
    import Button from '@/components/common/Button'
    import BoxCreationButton from "./BoxCreationButton"
    import ItemMenuList from'@/components/common/ItemMenuList'
    import MenuCard from'@/components/common/MenuCard'
    import Constants from "@/store/constants.js"

    export default {
        name: "BoxMenuList",
        //router, store,
        components: { ItemMenuList, MenuCard, Button, BoxCreationButton },
        mounted() {
        },
        computed: {
            Constants: () => Constants,
            ...mapState({
                boxListGrouped: state => state.stationBoxesGrouped,
                isLoading: state => state.loadingStates.isLoadingStationBoxes
            })
        },
        methods: {
            ...mapActions(['toggleCategory']),
            onBoxOpen: (box) => { console.log("Open Box"); },
            toggleSection: function (section) { this.toggleCategory(section); },
            isSmartBox(box) {
                return box.type === 'SMARTBOX' ? 'SmartBoxFilters' : 'BoxDetails';
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "global_var";
    .alert-info {
        align-self: flex-start;
        width: 100%;
        margin: 25px;
    }
    #m_aside_left #m_ver_menu.m-aside-menu .items-menu-container.grouped .list-group .list-group-item
    {
        margin-left:0;
    }
    .reset-style{
        li{
            list-style-type: none;
            a{
                &.router-link-active{
                    background: $BGCOLOR_MENU_RADIO_LEFT;
                }
            }
        }
    }
    .bar-item{
        position: absolute;
        margin-left:20px;
        top:50%; left: 5px;
        transform: translateY(-50%);
        width: 10px; height: 10px;
        border-radius: 100%;
        border-left: 3px solid transparent;
    }

</style>
